import styled from "styled-components";

interface IRowProps {
  marginTop?: string;
  marginBottom?: string;
}

export const Row = styled.div<IRowProps>`
  display: flex;
  margin-top: ${props => props.marginTop || '0px'};
  margin-bottom: ${props => props.marginBottom || '0px'};
`;

export const FieldGroup = styled.div<IRowProps>`
  display: flex;
  flex-direction: column;
  margin-top: ${props => props.marginTop || '0px'};
  margin-bottom: ${props => props.marginBottom || '0px'};
`;

export const FieldLabel = styled.div`
  color: #74777A;
  margin-bottom: 2px;
`;
